import * as gzFilterBar from './filter-bar.directive';
import './filter-bar.scss';
import gazelleAnalytics from '../../core/analytics/analytics.module';

export default angular.module('gazelle.components.filterBar', [
  'pascalprecht.translate',
  'angularMoment',
  'ngMaterial',
  'gazelle.components.filters',
  gazelleAnalytics
])
  .directive(gzFilterBar.name, gzFilterBar.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/filter-bar/filter-bar.module.js